"use client"

import CommonCreate from "@/components/common/Create"
import { useState } from "react"
import PartnersForm from "./PartnersForm"


const PartnersCreate = () => {
    const [formProp, setFormProp] = useState({
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        phone: "",
        percentage_commission: "",
        is_active: true
    });

    return (
        <CommonCreate title="Create" resource="referral-agents" data={{...formProp, phone: String(formProp.phone)}}>
            <PartnersForm formProp={formProp} setFormProp={setFormProp} mode="create" />
        </CommonCreate>
    );
};

export default PartnersCreate;
